/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CriticalElementDto,
  GetClientGoalCriticalElementsParams,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **Any authenticated role**
 */
export const getClientGoalCriticalElements = (
  userId: string,
  clientGoalId: number,
  params?: GetClientGoalCriticalElementsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CriticalElementDto[]>(
    {
      url: `/api/${userId}/goals/${clientGoalId}/critical-elements`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetClientGoalCriticalElementsQueryKey = (
  userId: string,
  clientGoalId: number,
  params?: GetClientGoalCriticalElementsParams
) => {
  return [
    `/api/${userId}/goals/${clientGoalId}/critical-elements`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClientGoalCriticalElementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientGoalCriticalElements>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientGoalId: number,
  params?: GetClientGoalCriticalElementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientGoalCriticalElements>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClientGoalCriticalElementsQueryKey(userId, clientGoalId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClientGoalCriticalElements>>
  > = ({ signal }) =>
    getClientGoalCriticalElements(
      userId,
      clientGoalId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && clientGoalId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientGoalCriticalElements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientGoalCriticalElementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientGoalCriticalElements>>
>;
export type GetClientGoalCriticalElementsQueryError = ErrorType<unknown>;

export function useGetClientGoalCriticalElements<
  TData = Awaited<ReturnType<typeof getClientGoalCriticalElements>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientGoalId: number,
  params: undefined | GetClientGoalCriticalElementsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientGoalCriticalElements>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientGoalCriticalElements>>,
          TError,
          Awaited<ReturnType<typeof getClientGoalCriticalElements>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientGoalCriticalElements<
  TData = Awaited<ReturnType<typeof getClientGoalCriticalElements>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientGoalId: number,
  params?: GetClientGoalCriticalElementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientGoalCriticalElements>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientGoalCriticalElements>>,
          TError,
          Awaited<ReturnType<typeof getClientGoalCriticalElements>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientGoalCriticalElements<
  TData = Awaited<ReturnType<typeof getClientGoalCriticalElements>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientGoalId: number,
  params?: GetClientGoalCriticalElementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientGoalCriticalElements>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClientGoalCriticalElements<
  TData = Awaited<ReturnType<typeof getClientGoalCriticalElements>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientGoalId: number,
  params?: GetClientGoalCriticalElementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientGoalCriticalElements>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClientGoalCriticalElementsQueryOptions(
    userId,
    clientGoalId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
